import React from "react";
import Space from "./Space";
import Float from "./Float";
import { kbdEvent } from "../utils/Utils";
import Label from "./Label";

export default function Nav(props) {

    const { nav = [], shim = false } = props;

    const wrap = (_text = "", _indices = [0]) => {
        let result = "";
        for (let i = 0; i < _text.length; i++) {
            const char = _text[i];
            if (_indices.includes(i)) {
                const isPunctuation = char === "," || char === ".";
                result += `<span class="bold${isPunctuation ? ' largeText' : ''}">${char}</span>`;
            } else {
                result += char;
            }
        }
        return `<div>${result}</div>`;
    }

    const drawLabel = (_str = "", _inds = [], _action, _key = false, type = "") => {


        if (type === "back" || type === "save") {
            return (
                <div
                    key={_str}
                    style={{ "opacity": (_key) ? "1" : "0.5"}}
                    onClick={() => (_key) ? kbdEvent(_key) : _action()}
                    className={"ui-nav-label " + type}
                ><strong>{_str}</strong>{(_key?.label && <small> ({_key?.label})</small>)}</div>
            )
        }

        return (
            <div
                key={_str}
                style={{ "opacity": (_key) ? "1" : "0.5" }}
                onClick={() => (_key) ? kbdEvent(_key) : _action()}
                className="ui-nav-label"
                dangerouslySetInnerHTML={{ __html: wrap(_str, _inds) }}
            />
        );
    };

    return (
        <div style={{ "width": "100%" }}>
            {(shim && <div style={{ "backgroundColor": "var(--border-primary)", "height": "1px", "width": "100%", "margin": "5px 0px" }}></div>)}
            <Float>
                <Space style={{ "padding": "0px 5px" }} size={4}>
                    {nav.filter(item => item.hasOwnProperty("text") && !item.hasOwnProperty("right")).map(item => {
                        const { text = "", inds = [0], key = false, type = "", action = () => { } } = item;

                        if(type === "shim"){
                            return(<div style={{"width" : "1px", "borderLeft" : "1px solid var(--border-secondary)", "margin" : "0px 4px"}}>&nbsp;</div>)
                        }

                        return drawLabel(text, inds, action, key, type);
                    })}
                </Space>
                <Space style={{ "padding": "0px 5px" }} size={4}>
                    {nav.filter(item => item.hasOwnProperty("text") && item.hasOwnProperty("right")).map(item => {
                        const { text = "", inds = [0], key = false, type = "", action = () => { } } = item;
                        return drawLabel(text, inds, action, key, type);
                    })}
                </Space>
            </Float>
            {(shim && <div className="shim" />)}
        </div>
    )
}